import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FileHandler from '@/mixins/file-handler';
import moment from 'moment';

var AppMultiImagesUploader = /*#__PURE__*/function (_mixins) {
  _inherits(AppMultiImagesUploader, _mixins);

  var _super = _createSuper(AppMultiImagesUploader);

  function AppMultiImagesUploader() {
    var _this;

    _classCallCheck(this, AppMultiImagesUploader);

    _this = _super.apply(this, arguments);
    _this.imageUrls = [];
    _this.imageIds = [];
    _this.ossPath = '';
    _this.targetImage = null;
    return _this;
  }

  _createClass(AppMultiImagesUploader, [{
    key: "mounted",
    value: function mounted() {
      if (this.urls) {
        this.imageUrls = _toConsumableArray(this.urls);
      }

      if (this.ids) {
        this.imageIds = this.ids.map(function (id) {
          return +id;
        });
      }
    }
  }, {
    key: "addFile",
    value: function addFile() {
      if (this.disabled) {
        return false;
      }

      var elem = this.$refs.fileBrowser;
      elem.value = null;
      elem.click();
    }
  }, {
    key: "previewImage",
    value: function previewImage(url) {
      this.targetImage = url;
    }
  }, {
    key: "closePreview",
    value: function closePreview() {
      this.targetImage = null;
    }
  }, {
    key: "onFileChanged",
    value: function () {
      var _onFileChanged = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var files, extension;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                files = e.target.files || e.dataTransfer.files;
                this.fileToUpload = files[0];

                if (this.checkCredentialValid()) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return this.getOSSCredentials();

              case 5:
                if (this.fileToUpload) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                extension = this.$R.last(this.fileToUpload.name.split('.'));
                this.ossPath = 'goods_covers/' + moment().format('YYYY/MM/DD') + moment().unix() + '.' + extension;
                _context.next = 11;
                return this.uploadFileToOSS(this.imageUrls);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onFileChanged(_x) {
        return _onFileChanged.apply(this, arguments);
      }

      return onFileChanged;
    }()
  }, {
    key: "deleteImage",
    value: function () {
      var _deleteImage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(index) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.disabled) {
                  this.imageUrls = this.$R.remove(index, 1, this.imageUrls);
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deleteImage(_x2) {
        return _deleteImage.apply(this, arguments);
      }

      return deleteImage;
    }()
  }, {
    key: "onValueChanged",
    value: function onValueChanged(val) {
      this.$emit('changed', {
        urls: val,
        ids: this.imageIds
      });
    }
  }, {
    key: "onUploadedChanged",
    value: function onUploadedChanged(val) {
      this.imageUrls = val;
    }
  }, {
    key: "onValueChanged1",
    value: function onValueChanged1(val) {
      this.imageUrls = val;
    }
  }]);

  return AppMultiImagesUploader;
}(mixins(FileHandler));

__decorate([Prop({
  type: Array
})], AppMultiImagesUploader.prototype, "urls", void 0);

__decorate([Prop({
  type: Array
})], AppMultiImagesUploader.prototype, "ids", void 0);

__decorate([Prop({
  type: [Number, String],
  default: '588'
})], AppMultiImagesUploader.prototype, "width", void 0);

__decorate([Prop({
  type: String
})], AppMultiImagesUploader.prototype, "label", void 0);

__decorate([Prop({
  type: Boolean
})], AppMultiImagesUploader.prototype, "required", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppMultiImagesUploader.prototype, "disabled", void 0);

__decorate([Watch('imageUrls', {
  deep: true
})], AppMultiImagesUploader.prototype, "onValueChanged", null);

__decorate([Watch('fileUploaded', {
  deep: true
})], AppMultiImagesUploader.prototype, "onUploadedChanged", null);

__decorate([Watch('urls', {
  deep: true
})], AppMultiImagesUploader.prototype, "onValueChanged1", null);

AppMultiImagesUploader = __decorate([Component({})], AppMultiImagesUploader);
export default AppMultiImagesUploader;